/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Slug_HintInputs */

const cs_settings_office_slug_hint = /** @type {(inputs: Settings_Office_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malá písmena, číslice a pomlčky. Interní id tenanta — není to veřejný web.`)
};

const en_settings_office_slug_hint = /** @type {(inputs: Settings_Office_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase letters, digits and hyphens. Internal tenant id — not the public website.`)
};

/**
* | output |
* | --- |
* | "Lowercase letters, digits and hyphens. Internal tenant id — not the public website." |
*
* @param {Settings_Office_Slug_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_slug_hint = /** @type {((inputs?: Settings_Office_Slug_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Slug_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_slug_hint(inputs)
	return cs_settings_office_slug_hint(inputs)
});